module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"title":"评价已完成。","subtitle":"感谢您的宝贵评价。","reward":"预计发放 {0}","my_reviews_button":"查看我的评价"}}')
  delete Component.options._Ctor
}
